import React from 'react'

const DraggableItem = ({
  item,
  dragHandleProps,
  commonProps
}: {
  item: any
  dragHandleProps: any
  commonProps: any
}) => {
  const Component = commonProps.component
  const { onMouseDown, onTouchStart } = dragHandleProps
  return (
    <div
      style={{
        userSelect: 'none'
      }}
      onTouchStart={(e) => {
        e.preventDefault()
        console.log('touchStart')
        document.body.style.overflow = 'hidden'
        onTouchStart(e)
      }}
      onMouseDown={(e) => {
        console.log('mouseDown')
        document.body.style.overflow = 'hidden'
        onMouseDown(e)
      }}
      onTouchEnd={(e) => {
        document.body.style.overflow = 'visible'
      }}
      onMouseUp={() => {
        document.body.style.overflow = 'visible'
      }}>
      <Component item={item} />
    </div>
  )
}

export default DraggableItem
